import { defineComponent as _defineComponent } from 'vue'
import FileUpload from "@/components/tools/FileUpload.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GifUpload',
  emits: ["upload"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "upload", file: File): void;
}), expose: any, slots: any, attrs: any }) {

const MAX_FILESIZE = 100 * 1024 * 1024; // 100MB



const onFileUpload = (file: File) => {
  emits("upload", file);
};

return { __sfc: true,MAX_FILESIZE, emits, onFileUpload, FileUpload }
}

})